import { Controller, useFormContext } from 'react-hook-form';
import { PublicTextFieldInput } from 'public/components/common/inputs/email-input';
import { FormEmailInputProps } from './types';

export const FormEmailInput = ({ label, name, required = false }: FormEmailInputProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, formState: { errors } }) => (
        <PublicTextFieldInput
          label={label}
          type="email"
          name={field.name}
          value={field.value ?? ''}
          onChange={field.onChange}
          error={errors[name]?.message as string}
          required={required}
        />
      )}
    />
  );
};
